// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3kzpn","choiceBoxes":"toolbarselects_choiceBoxes__4-rCa","simpleField":"toolbarselects_simpleField__F6Fqw"};